import dayjs from "dayjs";
import { GridColDef } from "@mui/x-data-grid";

//テーブル項目
export const columns: GridColDef[] = [
    {
        field: "rfc_request_date",
        headerName: "依頼受領日時",
        width: 135,
        headerAlign: "center",
        align: "center",
        disableColumnMenu: true,
        sortingOrder: ['desc', 'asc', null],
    },
    {
        field: "task_change_date",
        headerName: "タスク変更時間",
        width: 135,
        headerAlign: "center",
        align: "center",
        disableColumnMenu: true,
        sortingOrder: ['desc', 'asc', null],
    },
    {
        field: "elapsedTime",
        headerName: "経過営業時間",
        width: 130,
        headerAlign: "center",
        disableColumnMenu: true,
        sortComparator: (v1, v2) => {
            const elapsed1 = parseElapsedTimeToMinutes(v1);
            const elapsed2 = parseElapsedTimeToMinutes(v2);
            return elapsed1 - elapsed2;
        },
        sortingOrder: ['desc', 'asc', null],
    },
    {
        field: "plan_area_district_name",
        headerName: "地区",
        width: 100,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "plan_area_staff_name",
        headerName: "RFC",
        width: 110,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "plan_area_id",
        headerName: "候補地No",
        width: 100,
        headerAlign: "center",
        disableColumnMenu: true,
    },
    {
        field: "plan_area_name",
        headerName: "候補地名",
        width: 220,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "assembly",
        headerName: "組立",
        width: 100,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "pattern",
        headerName: "パターン",
        width: 80,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "branch",
        headerName: "枝",
        width: 50,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "status_name",
        headerName: "ステータス",
        width: 140,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "pic_type",
        headerName: "担当",
        width: 90,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "pic_name",
        headerName: "担当者名",
        width: 120,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "task_name",
        headerName: "タスク",
        width: 290,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "daily_sales_year_1",
        headerName: "初年度予測",
        width: 100,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "daily_sales_year_2",
        headerName: "2年度予測",
        width: 100,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "daily_sales_year_3",
        headerName: "3年度予測",
        width: 100,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "daily_sales_year_4",
        headerName: "4年度予測",
        width: 100,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "daily_sales_year_5",
        headerName: "5年度予測",
        width: 100,
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
    },
];

export interface portalTypeList {
    id: string;
    rfc_request_date: string;
    task_change_date: string;
    elapsedTime: string;
    elapsedFlag: string;
    plan_area_id: string;
    assembly: string;
    pattern: string;
    branch: string;
    status_id: string;
    status_name: string;
    pic_type: string;
    pic_name: string;
    task_id: string;
    task_name: string;
    reception_no: string;
    plan_area_name: string;
    plan_area_staff_number: string;
    plan_area_staff_name: string;
    plan_area_district_code: string;
    plan_area_district_name: string;
    plan_area_department_code: string;
    plan_area_department_name: string;
    reception_book_list: string;
    daily_sales_year_1: string;
    daily_sales_year_2: string;
    daily_sales_year_3: string;
    daily_sales_year_4: string;
    daily_sales_year_5: string;
}

export interface mailTypeList {
    id: string;
    conversion_create_date: string;
    task_create_date: string;
    elapsedTime: string;
    elapsedFlag: string;
    department: string;
    district: string;
    rfc: string;
    plan_area_id: string;
    candidateSiteName: string;
    assembly: string;
    pattern: string;
    branch: string;
    status_id: string;
    pic_type: string;
    pic_name: string;
    task_id: string;
    task_name: string;
    reception_no: string;
    plan_area_name: string;
    plan_area_staff_number: string;
    plan_area_staff_name: string;
    plan_area_district_code: string;
    plan_area_district_name: string;
    plan_area_department_code: string;
    plan_area_department_name: string;
    location_sales_forecast: string;
    reception_book_list: string;
}

export interface dataTypeList {
    id: string;
    plan_area_id: string;
    branch: string;
    status_seq: string;
    create_date: string;
    update_date: string;
    delete_flag: string;
    reception_no: string;
    status_id: string;
    task_id: string;
    status_task_update_date: string;
    pic_type: string;
    pic_name: string;
    pic_staff_number: string;
    pic_mail_address: string;
    pic_department_code: string;
    pic_department_name: string;
    pic_job_category_code: string;
    pic_job_category_name: string;
    assembly: string;
    pattern: string;
    pattern_details: string;
    comment: string;
    comment_type: string;
    plan_area_staff_number: string;
    plan_area_staff_name: string;
    plan_area_district_code: string;
    plan_area_district_name: string;
    plan_area_department_code: string;
    plan_area_department_name: string;
    rfc_request_date: string;
    task_change_date: string;
    temp_daily_sales_year_1: string;
    temp_daily_sales_year_2: string;
    temp_daily_sales_year_3: string;
    temp_daily_sales_year_4: string;
    temp_daily_sales_year_5: string;
    daily_sales_year_1: string;
    daily_sales_year_2: string;
    daily_sales_year_3: string;
    daily_sales_year_4: string;
    daily_sales_year_5: string;
    plan_area_name: string;
    status_name: string;
    task_name: string;
    task_name_id: string;
    reception_book_list: string;
    reception_book_summary_list: string;
    elapsedTime: string;
    elapsedFlag: string;
}

//テーブル表示用オブジェクト生成
export const findLatestBranch = (dataObj: dataTypeList[]) => {
    //グループ化
    const groupeByKeys: Record<string, dataTypeList[]> = {};

    //候補地No毎に切り分け
    dataObj.forEach((obj) => {
        const key = obj.plan_area_id;
        if (!groupeByKeys[key]) {
            groupeByKeys[key] = [];
        }
        groupeByKeys[key].push(obj);
    });

    const resultObj: dataTypeList[] = [];
    //一番新しい枝のレコードのみ特定して返却
    for (const key in groupeByKeys) {
        if (groupeByKeys.hasOwnProperty(key)) {
            const values = groupeByKeys[key];
            const latestBranch = values.sort(
                (a, b) =>
                    Number(b.branch.charCodeAt(0)) -
                    Number(a.branch.charCodeAt(0))
            )[0];
            if (latestBranch.rfc_request_date) {
                latestBranch.rfc_request_date = dayjs(
                    latestBranch.rfc_request_date
                ).format("YYYY-MM-DD HH:mm");
            }
            if (latestBranch.task_change_date) {
                latestBranch.task_change_date = dayjs(
                    latestBranch.task_change_date
                ).format("YYYY-MM-DD HH:mm");
            }

            if (latestBranch.branch === "1") {
                if (latestBranch.task_id === "C008") {
                    // 枝1の場合、C008の時だけ表示する
                    latestBranch.daily_sales_year_1 =
                        latestBranch.temp_daily_sales_year_1
                            ? latestBranch.temp_daily_sales_year_1 + "（仮）"
                            : "";
                    latestBranch.daily_sales_year_2 =
                        latestBranch.temp_daily_sales_year_2
                            ? latestBranch.temp_daily_sales_year_2 + "（仮）"
                            : "";
                    latestBranch.daily_sales_year_3 =
                        latestBranch.temp_daily_sales_year_3
                            ? latestBranch.temp_daily_sales_year_3 + "（仮）"
                            : "";
                    latestBranch.daily_sales_year_4 =
                        latestBranch.temp_daily_sales_year_4
                            ? latestBranch.temp_daily_sales_year_4 + "（仮）"
                            : "";
                    latestBranch.daily_sales_year_5 =
                        latestBranch.temp_daily_sales_year_5
                            ? latestBranch.temp_daily_sales_year_5 + "（仮）"
                            : "";
                } else {
                    latestBranch.daily_sales_year_1 = "";
                    latestBranch.daily_sales_year_2 = "";
                    latestBranch.daily_sales_year_3 = "";
                    latestBranch.daily_sales_year_4 = "";
                    latestBranch.daily_sales_year_5 = "";
                }
            } else {
                const preBranch = getPreBranch(latestBranch);
                latestBranch.daily_sales_year_1 = preBranch.daily_sales_year_1;
                latestBranch.daily_sales_year_2 = preBranch.daily_sales_year_2;
                latestBranch.daily_sales_year_3 = preBranch.daily_sales_year_3;
                latestBranch.daily_sales_year_4 = preBranch.daily_sales_year_4;
                latestBranch.daily_sales_year_5 = preBranch.daily_sales_year_5;
            }
            resultObj.push(latestBranch);
        }
    }
    resultObj.sort((a: any, b: any) => {
        return a.id - b.id;
    });
    return resultObj;
};

const getPreBranch = (latestBranch: any) => {
    const rblResponse = JSON.parse(latestBranch.reception_book_summary_list);
    const rbl = rblResponse.filter(
        (element: any, index: any, selfArray: any) => {
            return (
                index ===
                selfArray.findIndex((obj: any) => {
                    return obj.branch === element.branch;
                })
            );
        }
    );
    const preBranch = rbl.sort(
        (a: any, b: any) =>
            Number(b.branch.charCodeAt(0)) - Number(a.branch.charCodeAt(0))
    )[1];

    return preBranch;
};

export //テーブル表示用オブジェクト 表示用データへ変換
const dataOptimization = (res: dataTypeList[], picTypeList: any[]) => {
    //担当IDから担当へ変更
    const setPicTypeCodedDisplay = (pic_type: string) => {
        let pic_type_code_display = pic_type;
        picTypeList?.map((row: any) => {
            if (row.value === pic_type) {
                pic_type_code_display = row.label;
            }
        });
        return pic_type_code_display;
    };
    //コード値からパターン名へ変換
    const setPatternCodeDisplay = (pattern: string) => {
        let pattern_code_display = pattern; //戻り値
        const codeMasterObj = localStorage.getItem("codeMaster");
        if (codeMasterObj !== null) {
            const jsonCodeMasterObj = JSON.parse(codeMasterObj);
            const patternList = jsonCodeMasterObj.pattern; //コードマスタからパターンのリスト取得
            patternList?.map((row: any) => {
                if (row.code_value === pattern) {
                    pattern_code_display = row.code_display;
                }
            });
        }
        return pattern_code_display;
    };
    //組立名称設定
    const setAssemblyDisplay = (assembly: string) => {
        let assembly_code_display = assembly; //戻り値
        const codeMasterObj = localStorage.getItem("codeMaster");
        if (codeMasterObj !== null) {
            const jsonCodeMasterObj = JSON.parse(codeMasterObj);
            const assemblyList = jsonCodeMasterObj.assembly; //コードマスタから組立のリスト取得
            assemblyList?.map((row: any) => {
                if (row.code_value === assembly_code_display) {
                    assembly_code_display = `${assembly}:${row.code_display}`;
                }
            });
        }
        return assembly_code_display;
    };
    const dataList: portalTypeList[] = [];
    res.map((data) => {
        const dataObj = {
            id: data.id,
            rfc_request_date: data.rfc_request_date,
            task_change_date: data.task_change_date,
            elapsedTime: data.elapsedTime,
            elapsedFlag: data.elapsedFlag,
            plan_area_id: data.plan_area_id,
            assembly: setAssemblyDisplay(data.assembly),
            pattern: setPatternCodeDisplay(data.pattern),
            branch: data.branch,
            status_id: data.status_id,
            status_name: data.status_name,
            pic_type: setPicTypeCodedDisplay(data.pic_type),
            pic_name: data.pic_name,
            task_id: data.task_id,
            task_name: data.task_name,
            reception_no: data.reception_no,
            plan_area_name: data.plan_area_name,
            plan_area_staff_number: data.plan_area_staff_number,
            plan_area_staff_name: data.plan_area_staff_name,
            plan_area_district_code: data.plan_area_district_code,
            plan_area_district_name: data.plan_area_district_name,
            plan_area_department_code: data.plan_area_department_code,
            plan_area_department_name: data.plan_area_department_name,
            reception_book_list: data.reception_book_list,
            daily_sales_year_1: data.daily_sales_year_1,
            daily_sales_year_2: data.daily_sales_year_2,
            daily_sales_year_3: data.daily_sales_year_3,
            daily_sales_year_4: data.daily_sales_year_4,
            daily_sales_year_5: data.daily_sales_year_5,
        };
        dataList.push(dataObj);
    });
    return dataList;
};

//経過時間の日、時間、分を分に変換する関数 ソート時に使用
export const parseElapsedTimeToMinutes = (elapsedTime: string) => {
    let days = 0,
        hours = 0,
        minutes = 0;
    const dayMatch = elapsedTime.match(/(\d+)日/);
    if (dayMatch) days = parseInt(dayMatch[1], 10);
    const hourMatch = elapsedTime.match(/(\d+)時間/);
    if (hourMatch) hours = parseInt(hourMatch[1], 10);
    const minuteMatch = elapsedTime.match(/(\d+)分/);
    if (minuteMatch) minutes = parseInt(minuteMatch[1], 10);
    return days * 24 * 60 + hours * 60 + minutes;
};
